import type { FC } from 'react';
import React from 'react';

import { Icon as IconPresenter } from '../../Icon/Icon';
import { composeU } from '../../lib/compose';
import { withGlyphTypeIndeterminate } from '../_glyphs/Indeterminate';
import { withGlyphTypeTick } from '../_glyphs/Tick';
import { cnCheckbox } from '../Checkbox.cn';

import './Checkbox-Tick.css';

const Icon = composeU(withGlyphTypeTick, withGlyphTypeIndeterminate)(IconPresenter);

// @analyze-exports:disable
export interface ICheckboxTickProps {
    indeterminate?: boolean;
    className?: string;
}

// @analyze-exports:disable
export const CheckboxTick: FC<ICheckboxTickProps> = ({ className, indeterminate, ...props }) => {
    const glyph = indeterminate ? 'type-indeterminate' : 'type-tick';
    return (
        <span {...props} className={cnCheckbox('Tick', null, className)}>
            <Icon glyph={glyph} />
        </span>
    );
};
